import { TreeNode, TreeNodeProps } from "@mcleod/components";
import { MenuItem } from "@mcleod/core";

export interface MenuTreeNodeProps extends TreeNodeProps {
    menuItem: MenuItem;
}

export class MenuTreeNode extends TreeNode {
    menuItem: MenuItem;
    protected isInitialized: boolean;
    constructor(props: Partial<MenuTreeNodeProps>) {
        super({
            fontSize: "small",
            fontBold: true,
            text: props.menuItem?.caption,
            allowSelect: false,
            rowBreak: false,
            fillRow: true,
            ...props
        });
        this.label.style.lineHeight = "16px";
        this.padding = 0;
        this.isInitialized = true;
    }
}
